 import { gatewayRequestAxios } from './interceptor'
import { GATEWAY_API_DATA_URL } from '../constants/urls'

export const fetchCountries = () => gatewayRequestAxios.get(`${GATEWAY_API_DATA_URL}`)
